import React from 'react'
import "./style.scss"

export const Maintenance = () => {
    return (
        <div className="maintenance">
            <div>Sito in manutenzione :(</div>
        </div>
    )
}